import styled from "styled-components";

export const StyledFormHeader = styled.header`

    margin-bottom: 35px;
    max-width: 100vw;
`